exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".order-card[data-v-23698158]{top:30px;transform:translateY(20%);width:100%}.wrapper-position[data-v-23698158]{max-width:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-23698158&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ThankYouPage.vue
// module id = 56
// module chunks = 0